import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
    departmentId:""
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setDepartment: (state, action: PayloadAction<string>) => {
      state.departmentId = action.payload;
    },
    resetDepartment: (state) => {
      state.departmentId = initialState.departmentId;
    },
  },
});
export const selectDepartmentState=(state:RootState)=>state?.department?.departmentId || ""
export const { setDepartment,resetDepartment } = departmentSlice.actions;
export default departmentSlice.reducer;